export enum EventName {
    ToastError = 'ToastError',
    FatalError = 'FatalError',
    ExportGraph = 'ExportGraph',
}